
<div class="p-6 space-y-6" id="page-dashboard">
  <div class="lg:grid-cols-4 grid grid-cols-2 gap-4">
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-5 border border-gray-100 dark:border-gray-800">
      <div class="items-center justify-between mb-3 flex">
        <span class="text-xs font-semibold text-gray-400 tracking-wider dark:text-gray-500 uppercase">Clientes
                  Activos</span>
        <div class="w-9 h-9 rounded-xl bg-orange-100 dark:bg-orange-900/30 items-center justify-center flex">
          <svg class="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_5Ztdo0Fqq"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
        </div>
      </div>
      <p class="text-3xl font-bold text-gray-900 dark:text-white">48</p>
      <p class="text-xs text-green-500 font-medium mt-1">↑ +3 este mes</p>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-5 border border-gray-100 dark:border-gray-800">
      <div class="items-center justify-between mb-3 flex">
        <span class="text-xs font-semibold text-gray-400 tracking-wider dark:text-gray-500
                  uppercase">Proyectos</span>
        <div class="w-9 h-9 rounded-xl bg-blue-100 dark:bg-blue-900/30 items-center justify-center flex">
          <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_UYUjuOXYs"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
        </div>
      </div>
      <p class="text-3xl font-bold text-gray-900 dark:text-white">127</p>
      <p class="text-xs text-green-500 font-medium mt-1">↑ +12 este mes</p>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-5 border border-gray-100 dark:border-gray-800">
      <div class="items-center justify-between mb-3 flex">
        <span class="text-xs font-semibold text-gray-400 tracking-wider dark:text-gray-500 uppercase">Tareas
                  Pendientes</span>
        <div class="w-9 h-9 rounded-xl bg-yellow-100 dark:bg-yellow-900/30 items-center justify-center flex">
          <svg class="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_oF0AV8s07"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </div>
      </div>
      <p class="text-3xl font-bold text-gray-900 dark:text-white">34</p>
      <p class="text-xs text-yellow-500 font-medium mt-1">⚠ 5 vencen hoy</p>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-5 border border-gray-100 dark:border-gray-800">
      <div class="items-center justify-between mb-3 flex">
        <span class="text-xs font-semibold text-gray-400 tracking-wider dark:text-gray-500
                  uppercase">Completados</span>
        <div class="w-9 h-9 rounded-xl bg-green-100 dark:bg-green-900/30 items-center justify-center flex">
          <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_geWX0MoBd"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </div>
      </div>
      <p class="text-3xl font-bold text-gray-900 dark:text-white">89</p>
      <p class="text-xs text-green-500 font-medium mt-1">↑ 70% tasa éxito</p>
    </div>
  </div>
  <div class="lg:grid-cols-3 grid grid-cols-1 gap-6">
    <div class="lg:col-span-2 bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-6 border border-gray-100
              dark:border-gray-800">
      <div class="items-center justify-between mb-6 flex">
        <h3 class="text-base font-bold text-gray-800 dark:text-white">Progreso de Proyectos por Mes</h3>
        <select class="border-0 dark:text-gray-400 focus:outline-none text-xs bg-gray-100
                  dark:bg-gray-800 rounded-lg px-3 py-1.5 text-gray-600">
          <option>2024</option>
          <option>2023</option>
        </select>
      </div>
      <div class="items-end h-44 flex gap-3">
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 60%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Ene</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 75%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Feb</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 50%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Mar</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 90%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Abr</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 65%;" class="w-full rounded-t-lg bg-linear-to-t from-blue-500 to-blue-300"></div>
          <span class="text-xs text-gray-400">May</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 80%;" class="w-full rounded-t-lg bg-linear-to-t from-blue-500 to-blue-300"></div>
          <span class="text-xs text-gray-400">Jun</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 70%;" class="w-full rounded-t-lg bg-linear-to-t from-green-500
                    to-green-300"></div>
          <span class="text-xs text-gray-400">Jul</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 55%;" class="w-full rounded-t-lg bg-linear-to-t from-green-500
                    to-green-300"></div>
          <span class="text-xs text-gray-400">Ago</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 85%;" class="w-full rounded-t-lg bg-linear-to-t from-green-500
                    to-green-300"></div>
          <span class="text-xs text-gray-400">Sep</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 100%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Oct</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 72%;" class="w-full rounded-t-lg bg-linear-to-t from-orange-500
                    to-orange-300"></div>
          <span class="text-xs text-gray-400">Nov</span>
        </div>
        <div class="items-center flex flex-col gap-1 flex-1">
          <div style="height: 45%;" class="w-full rounded-t-lg bg-linear-to-t from-red-500 to-red-300"></div>
          <span class="text-xs text-gray-400">Dic</span>
        </div>
      </div>
      <div class="items-center mt-4 flex gap-4">
        <span class="items-center text-xs text-gray-500 flex gap-1.5">
          <span class="w-3 h-3 bg-orange-400 rounded inline-block"></span>
          En proceso
        </span>
        <span class="items-center text-xs text-gray-500 flex gap-1.5">
          <span class="w-3 h-3 bg-green-400 rounded inline-block"></span>
          Completados
        </span>
        <span class="items-center text-xs text-gray-500 flex gap-1.5">
          <span class="w-3 h-3 bg-blue-400 rounded inline-block"></span>
          En revisión
        </span>
        <span class="items-center text-xs text-gray-500 flex gap-1.5">
          <span class="w-3 h-3 bg-red-400 rounded inline-block"></span>
          Vencidos
        </span>
      </div>
    </div>
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-800">
      <h3 class="text-base font-bold text-gray-800 mb-6 dark:text-white">Estado General</h3>
      <div class="items-center justify-center mb-6 flex">
        <div class="w-36 h-36 relative">
          <svg viewBox="0 0 36 36" class="w-36 h-36 -rotate-90" id="Windframe_zBXB9j5kY">
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#f3f4f6" stroke-width="3" class="dark:stroke-gray-800"></circle>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#22c55e" stroke-width="3" stroke-dasharray="44 56" stroke-dashoffset="0"></circle>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#f97316" stroke-width="3" stroke-dasharray="26 74" stroke-dashoffset="-44"></circle>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#3b82f6" stroke-width="3" stroke-dasharray="20 80" stroke-dashoffset="-70"></circle>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#ef4444" stroke-width="3" stroke-dasharray="10 90" stroke-dashoffset="-90"></circle>
              </svg>
          <div class="items-center justify-center absolute inset-0 flex flex-col">
            <span class="text-2xl font-bold text-gray-800 dark:text-white">127</span>
            <span class="text-xs text-gray-400">proyectos</span>
          </div>
        </div>
      </div>
      <div class="space-y-2">
        <div class="items-center justify-between text-sm flex">
          <span class="items-center flex gap-2">
            <span class="w-3 h-3 rounded-full bg-green-500 inline-block"></span>
            <span class="text-gray-600 dark:text-gray-400">Completados</span>
          </span>
          <span class="font-semibold text-gray-800 dark:text-gray-200">56 (44%)</span>
        </div>
        <div class="items-center justify-between text-sm flex">
          <span class="items-center flex gap-2">
            <span class="w-3 h-3 rounded-full bg-orange-500 inline-block"></span>
            <span class="text-gray-600 dark:text-gray-400">En proceso</span>
          </span>
          <span class="font-semibold text-gray-800 dark:text-gray-200">33 (26%)</span>
        </div>
        <div class="items-center justify-between text-sm flex">
          <span class="items-center flex gap-2">
            <span class="w-3 h-3 rounded-full bg-blue-500 inline-block"></span>
            <span class="text-gray-600 dark:text-gray-400">En revisión</span>
          </span>
          <span class="font-semibold text-gray-800 dark:text-gray-200">25 (20%)</span>
        </div>
        <div class="items-center justify-between text-sm flex">
          <span class="items-center flex gap-2">
            <span class="w-3 h-3 rounded-full bg-red-500 inline-block"></span>
            <span class="text-gray-600 dark:text-gray-400">Vencidos</span>
          </span>
          <span class="font-semibold text-gray-800 dark:text-gray-200">13 (10%)</span>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800
            overflow-hidden">
    <div class="items-center justify-between px-6 py-4 flex border-b border-gray-100 dark:border-gray-800">
      <h3 class="text-base font-bold text-gray-800 dark:text-white">Proyectos Recientes</h3>
      <a routerLink="/proyectos" class="text-xs text-primary hover:opacity-80 font-semibold">Ver todos →</a>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-6 py-3 dark:text-gray-500
                      uppercase">Proyecto</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Cliente</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Tipo</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Estado</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Avance</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Vencimiento</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50 dark:divide-gray-800">
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4 text-sm font-medium text-gray-800 dark:text-gray-200">Licencia Construcción Lote
                      14</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Constructora Azteca</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-1 rounded-lg font-medium
                        dark:text-blue-400">Construcción</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-1 rounded-lg
                        font-medium dark:text-orange-400">En proceso</span>
            </td>
            <td class="px-4 py-4">
              <div class="items-center flex gap-2">
                <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-1.5 flex-1">
                  <div style="width: 65%;" class="bg-orange-500 h-1.5 rounded-full"></div>
                </div>
                <span class="text-xs text-gray-500">65%</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-red-500 font-medium">15 Nov 2024</td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4 text-sm font-medium text-gray-800 dark:text-gray-200">Permiso Ambiental Zona
                      Norte</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Inmobiliaria del Norte</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-1 rounded-lg
                        font-medium dark:text-green-400">Ambiental</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-1 rounded-lg font-medium
                        dark:text-blue-400">En revisión</span>
            </td>
            <td class="px-4 py-4">
              <div class="items-center flex gap-2">
                <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-1.5 flex-1">
                  <div style="width: 80%;" class="bg-blue-500 h-1.5 rounded-full"></div>
                </div>
                <span class="text-xs text-gray-500">80%</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-500">28 Nov 2024</td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4 text-sm font-medium text-gray-800 dark:text-gray-200">Registro Marca
                      Comercial</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">TechSoluciones MX</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 px-2 py-1 rounded-lg
                        font-medium dark:text-purple-400">Mercantil</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-1 rounded-lg
                        font-medium dark:text-green-400">Completado</span>
            </td>
            <td class="px-4 py-4">
              <div class="items-center flex gap-2">
                <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-1.5 flex-1">
                  <div style="width: 100%;" class="bg-green-500 h-1.5 rounded-full"></div>
                </div>
                <span class="text-xs text-gray-500">100%</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-500">05 Oct 2024</td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4 text-sm font-medium text-gray-800 dark:text-gray-200">Apertura de
                      Establecimiento</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Grupo Empresarial Alfa</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 px-2 py-1 rounded-lg
                        font-medium dark:text-yellow-400">Comercial</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-red-100 dark:bg-red-900/30 text-red-600 px-2 py-1 rounded-lg font-medium
                        dark:text-red-400">Vencido</span>
            </td>
            <td class="px-4 py-4">
              <div class="items-center flex gap-2">
                <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-1.5 flex-1">
                  <div style="width: 40%;" class="bg-red-500 h-1.5 rounded-full"></div>
                </div>
                <span class="text-xs text-gray-500">40%</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-red-500 font-medium">01 Oct 2024</td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4 text-sm font-medium text-gray-800 dark:text-gray-200">Uso de Suelo Comercial</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Constructora Azteca</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-1 rounded-lg font-medium
                        dark:text-blue-400">Construcción</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-1 rounded-lg
                        font-medium dark:text-orange-400">En proceso</span>
            </td>
            <td class="px-4 py-4">
              <div class="items-center flex gap-2">
                <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-1.5 flex-1">
                  <div style="width: 35%;" class="bg-orange-500 h-1.5 rounded-full"></div>
                </div>
                <span class="text-xs text-gray-500">35%</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-500">20 Dic 2024</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
